// This file was automatically generated from ptdata.model.noteItem.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.model.noteItem');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.noteItem.summary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('\t', soy.$$escapeHtml(opt_data.text), ' <span class="el8SystemText">-- ', soy.$$escapeHtml(opt_data.userName), ', ', (soy.$$escapeHtml(opt_data.recordDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.recordDate)) : ''), '</span>');
  if (!opt_sb) return output.toString();
};
